import { LocalTaxi } from "@mui/icons-material";

let localHost = 'http://localhost:3001/';
let api = 'https://pec-api.herokuapp.com/';
let awsApi = 'http://pecapi-env.eba-smmeuv7c.us-east-2.elasticbeanstalk.com/'
export const API = api;
//
export const usercreds = JSON.parse(sessionStorage.getItem('profile-data'))